module.exports = __webpack_public_path__ + "images/my-integral-icon-earn.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/my-integral-icon-earn.png
// module id = 890
// module chunks = 125